import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'KM',
  name: 'K.M.',
  role: 'Dance Teacher | London, UK',
  text: '"I used to spend every Sunday night rebuilding the same warm-ups and across-the-floor combinations. Now I open the library, pick the class, and walk in completely ready. My students feel the difference — and honestly, so do I."'
}, {
  initials: 'TR',
  name: 'T.R.',
  role: 'Dance Instructor | Toronto, Canada',
  text: '"The emergency classes alone saved me three times in my first month. A substitute request came in at 7am and I had a full structured lesson ready in under five minutes. That bonus is worth the entire price."'
}, {
  initials: 'AS',
  name: 'A.S.',
  role: 'Dance Teacher | Sydney, Australia',
  text: '"The cueing library completely changed how I correct. I stopped fumbling for words mid-class and started giving adjustments that actually landed. My students are progressing faster and I\'m teaching with so much more confidence."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-274">
      <div className="max-w-7xl mx-auto px-4" data-id="element-275">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-276">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-277">
              <div className="flex gap-1 text-gold mb-4" data-id="element-278">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-279" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-280">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-281">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-282">
                  {t.initials}
                </div>
                <div data-id="element-283">
                  <div className="font-bold text-white text-sm" data-id="element-284">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-285">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}